import { render } from "./record-msg-box.vue?vue&type=template&id=71e10f68&scoped=true&ts=true"
import script from "./record-msg-box.vue?vue&type=script&lang=ts"
export * from "./record-msg-box.vue?vue&type=script&lang=ts"

import "./record-msg-box.vue?vue&type=style&index=0&id=71e10f68&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e10f68"]])

export default __exports__